/*
 * @Description: 机构常量名
 */
class Keys {
    static tokenKey = 'jigou-access-token'
    static aseKey = 'jigou-ase-key'
    static liveBroadcast = 'jigou-live-broadcast-key'
    static broadcast = 'jigou-recorded-broadcast-key'
    static layout = 'jigou-void-layout'
  }
  
  export default Keys
  